console.log("TERMS LOADED")

class TermsLink extends HTMLButtonElement {
  constructor() {
    super();
  
    this.popup = document.querySelector(`#terms-${this.dataset.blockId}`)

  }

  connectedCallback() {

    this.addEventListener("click", () => {
      this.popup.classList.add("show-terms")
      document.querySelector("terms-overlay").classList.add("show-terms")
      this.blur()
      this.dataset.acsbFocused = false
      this.popup.tabindex = 0
      this.popup.dataset.acsbFocused = true
      this.popup.click()
      this.popup.focus()
    })

    this.popup.addEventListener("keyup", () => {
      console.log("yes")
    if (event.key === "Escape") {
      console.log("YES CLICKED")
      this.popup.classList.remove("show-terms") 
      this.popup.dataset.acsbFocused = false
      document.querySelector("terms-overlay").classList.remove("show-terms")
      this.dataset.acsbFocused = true
      this.focus()
    }
    })

    this.popup.addEventListener("focusout", () => {
      this.popup.classList.remove("show-terms") 
      this.popup.dataset.acsbFocused = false
      document.querySelector("terms-overlay").classList.remove("show-terms")
      this.dataset.acsbFocused = true
      this.focus()
    })

  }

}

class TermsOverlay extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", () => {
      document.querySelectorAll(".terms-popup").forEach((i) => {
        i.classList.remove("show-terms")
      })
      this.classList.remove("show-terms")
    })
  }
}


customElements.define("terms-link", TermsLink, { extends: "button" } )
customElements.define("terms-overlay", TermsOverlay)
